export class ContactUsMessageModel {
    type?: string | undefined;
    subject?: string | undefined;
    senderName?: string | undefined;
    senderEmail?: string | undefined;
    body?: string | undefined;
}
